var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 27,
    viewBox: "0 0 24 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "style=linear"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 21059"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.4118 2.7702L3.47986 13.2828C3.10485 13.682 2.74193 14.4683 2.66934 15.0127L2.22174 18.9323C2.06448 20.3476 3.08065 21.3154 4.48394 21.0735L8.37927 20.4081C8.92365 20.3113 9.68582 19.9121 10.0608 19.5008L19.9927 8.98822C21.7106 7.17363 22.4848 5.10498 19.8113 2.57664C17.1499 0.0725007 15.1296 0.955605 13.4118 2.7702Z",
    stroke: "#008556",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.7545 4.52441C12.2747 7.86327 14.9845 10.4158 18.3476 10.7545",
    stroke: "#008556",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M1 25.0293H22.7752",
    stroke: "#008556",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenEdit);
export default __webpack_public_path__ + "static/media/greenEdit.9a74181885678f41ada2b155fcea0168.svg";
export { ForwardRef as ReactComponent };